module.exports = __webpack_public_path__ + "img/onboarding_collectomate.01594555.png";